import { CountryCode, Flag } from "@airhelp/flags";
import { Box, chakra } from "@chakra-ui/react";

export function ActionButton({
  flagKey,
  locale,
  handleClick,
}: {
  flagKey: CountryCode;
  locale: string;
  handleClick: () => void;
}) {
  return (
    <chakra.button
      color="font.primary"
      _hover={{ md: { color: "primary.500" } }}
      _focus={{ bg: "none" }}
      _active={{ bg: "none" }}
      fontSize="md"
      cursor="pointer"
      fontWeight="medium"
      display="inline-flex"
      alignItems="center"
      gap={2}
      m={2}
      p={2}
      onClick={handleClick}
      data-testid="languageSwitcherButton"
    >
      <Box transform={"translateY(-1px)"}>
        <Flag size="xs" code={flagKey} />
      </Box>
      {locale.substring(0, 2).toUpperCase()}
    </chakra.button>
  );
}
